<template>
<div id="dashboard-layout">
<!-- Navigation-->
  <nav class="navbar navbar-expand-lg fixed-top navbar-dark bg-dark" id="mainNav">
    <router-link to="/" class="navbar-brand">{{ $t('brand') }}  </router-link>

    <span class="not-prod bg-warning" v-if="env != 'PRODUCTION'"> - ( {{ env }} ) - </span>

    <button @click="toggleMobileMenu" class="navbar-toggler navbar-toggler-right" type="button" data-target="#navbarResponsive" aria-controls="navbarResponsive" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse" id="navbarResponsive">
      <ul class="navbar-nav navbar-sidenav">

        <li v-for="route in routes" v-if="checkPermission(route) && !route.meta.hide" class="nav-item" data-toggle="tooltip" data-placement="right" :title="$t(route.meta.title)">
          <router-link :to="route.path" class="nav-link">
            <i :class="'fa fa-fw fa-' + route.meta.ico + ' fa-lg'"></i>
            <span class="nav-link-text">{{ $t(route.meta.title) }}</span>
          </router-link>
        </li>

      </ul>

      <ul class="navbar-nav sidenav-toggler">
        <li class="nav-item">
          <a class="nav-link text-center" id="sidenavToggler">
            <i class="fa fa-fw fa-angle-left"></i>
          </a>
        </li>
      </ul>

      <ul class="navbar-nav ml-auto">
        <li class="nav-link " ><a href="#" @click="printPage()"><i class="fa fa-fw fa-print fa-lg text-light"></i></a></li>
        <b-nav-item-dropdown id="nav7_ddown" :text="currentUser.fullName" right>
          <b-dropdown-item>
            <router-link to="/profile">
              <i class="fa fa-fw fa-user"></i>{{$t("user.profile")}}
            </router-link>
          </b-dropdown-item>
          <b-dropdown-divider></b-dropdown-divider>
          <b-dropdown-item>
            <a href="#" v-on:click="logout">
              <i class="fa fa-fw fa-sign-out"></i>{{ $t('authentification.logoff') }}
            </a>
          </b-dropdown-item>
        </b-nav-item-dropdown>
      </ul>

    </div>
  </nav>

  <div class="content-wrapper">
    <div class="container-fluid">
          <!-- Dashboard Content -->
          <router-view></router-view>
    </div>
  </div>

  <footer class="sticky-footer">
    <div class="container">
      <div class="row">
        <div class="col-sm-6">
          <small>{{ $t('copyright', { year : year})  }} </small>
        </div>
        <div class="col-sm-6 text-right">
          <img src="https://www.spk.rocks/static/svg/production-spektrum.svg" alt="Une production Spektrum Media" height="40px"/>
        </div>
      </div>
    </div>
  </footer>
    <!-- Scroll to Top Button-->
    <a class="scroll-to-top rounded" href="#page-top">
      <i class="fa fa-angle-up"></i>
    </a>
  </div>
</template>

<script>
import permission from '../shared/permission'
import ServiceFactory from '../shared/service-clients/serviceClientFactory'
import {RoleServiceClient} from '../shared/service-clients/service-clients'

export default {
  name: 'dashboard',
  data() {
    return {
      currentUser: this.$store.state.currentUser,
      year: new Date().getFullYear(),
      profileMenuVisible: false,
      routes: [],
      env: this.$store.state.env.toUpperCase(),
      interval: null,
    }
  },
  beforeDestroy: function() {
    clearInterval(this.interval)
  },
  mounted: function() {
    // ping the server every 10 min to make sure we dont go out of session and break things
    this.interval = setInterval(
      function() {
        let pingService = ServiceFactory.create(RoleServiceClient)
        pingService.getAll(1000, 1).then(_ => {})
      }.bind(this),
      1000 * 60 * 10
    )

    this.routes = _.find(this.$router.options.routes, function(f) {
      return f.path == '/dashboard'
    }).children

    // Configure tooltips for collapsed side navigation
    $('.navbar-sidenav [data-toggle="tooltip"]').tooltip({
      template:
        '<div class="tooltip navbar-sidenav-tooltip" role="tooltip"><div class="arrow"></div><div class="tooltip-inner"></div></div>',
    })
    // Toggle the side navigation
    $('#sidenavToggler').click(function(e) {
      e.preventDefault()
      $('body').toggleClass('sidenav-toggled')
      $('.navbar-sidenav .nav-link-collapse').addClass('collapsed')
      $('.navbar-sidenav .sidenav-second-level, .navbar-sidenav .sidenav-third-level').removeClass('show')
    })
    // Force the toggled class to be removed when a collapsible nav link is clicked
    $('.navbar-sidenav .nav-link-collapse').click(function(e) {
      e.preventDefault()
      $('body').removeClass('sidenav-toggled')
    })
    // Prevent the content wrapper from scrolling when the fixed side navigation hovered over
    $('body.fixed-nav .navbar-sidenav, body.fixed-nav .sidenav-toggler, body.fixed-nav .navbar-collapse').on(
      'mousewheel DOMMouseScroll',
      function(e) {
        var e0 = e.originalEvent,
          delta = e0.wheelDelta || -e0.detail
        this.scrollTop += (delta < 0 ? 1 : -1) * 30
        e.preventDefault()
      }
    )
    // Scroll to top button appear
    $(document).scroll(function() {
      var scrollDistance = $(this).scrollTop()
      if (scrollDistance > 100) {
        $('.scroll-to-top').fadeIn()
      } else {
        $('.scroll-to-top').fadeOut()
      }
    })
    // Configure tooltips globally
    $('[data-toggle="tooltip"]').tooltip()
    // Smooth scrolling using jQuery easing
    $(document).on('click', 'a.scroll-to-top', function(event) {
      $('html, body')
        .stop()
        .animate(
          {
            scrollTop: 0,
          },
          1000,
          'easeInOutExpo'
        )
      event.preventDefault()
    })
  },
  methods: {
    printPage: function() {
      window.print()
    },
    checkPermission(route) {
      if (route.meta == null) return false

      return permission.checkPermission(route.meta.permission)
    },
    logout: function() {
      this.$store.commit('logout')
      this.$router.push('login')
    },
    showProfileMenu: function() {
      this.profileMenuVisible = true
    },
    toggleMobileMenu: function(event) {
      var $element = $('#navbarResponsive')

      if ($element.hasClass('collapse')) {
        $element
          .removeClass('collapse')
          .addClass('collapsing')
          .animate(
            {
              'min-height': '300',
            },
            400,
            function() {}
          )
      } else {
        $element.animate(
          {
            'min-height': '0',
          },
          400,
          function() {
            $element.removeClass('collapsing').addClass('collapse')
          }
        )
      }
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.dropdown-item i.fa{
  margin-right: 10px;
  margin-left: -10px;
}

/* Enter and leave animations can use different */
/* durations and timing functions.              */
.slide-fade-enter-active {
  transition: all .3s ease;
}
.slide-fade-leave-active {
  transition: all .3s ease;
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateY(-100%);
  opacity: 0.5;
}

.slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateY(100%);
  opacity: 0.5;
}

</style>



// WEBPACK FOOTER //
// src/components/Dashboard.vue